export default {
	"fbbcd10d1f1e730217a0d22f496ae915": "Failed to redirect to customer service",
	"e3a203abb5cfd142073e1808281c64b0": "Cancel",
	"1120daef6b846405d5c2ddcb17368afd": "Contact customer service"
}
